import { countries, usStates } from "./schema";

/**
 * Bridges the two conflicting US-state identifier systems in this codebase:
 *
 *   - the programmatic SEO family, the sitemap and the breadcrumb links all use
 *     the FULL-NAME slug ("us-texas", "us-new-york") — see COUNTRY_CODES in
 *     scripts/generate-programmatic.ts
 *   - the React calculator and the tax engine use the 2-LETTER code ("TX")
 *
 * Nothing reconciled them, so /calculator/us-texas fell through to the homepage
 * meta (canonical "/") while /calculator/us-tx was the only working state hub —
 * and that URL was never in the sitemap. This module is the single mapping.
 */
export interface StateSlug {
  slug: string; // "us-texas"
  name: string; // "Texas"
  code: string; // "TX"
  taxRate: number; // headline state rate, % — used on hub copy
}

const list: StateSlug[] = [];
for (const c of countries) {
  const code: string = c.code;
  if (!code.startsWith("us-")) continue;
  const st = usStates.find((s) => s.name === c.name);
  if (!st) continue;
  list.push({ slug: code, name: c.name, code: st.code, taxRate: st.taxRate });
}

export const US_STATE_SLUGS: StateSlug[] = list;

export const stateBySlug: Map<string, StateSlug> = new Map(
  list.map((s) => [s.slug, s] as [string, StateSlug]),
);

export const stateByCode: Map<string, StateSlug> = new Map(
  list.map((s) => [s.code, s] as [string, StateSlug]),
);
